import React, { useState, useEffect, useRef } from 'react';
import './MySlider.css';

const MySlider = ({ 
  value, 
  onChange, 
  disabled, 
  min = 0, 
  max = 100, 
  step = 1, 
  showLabels = true,
  showValue = true,
  valuePrefix = '',
  valueSuffix = '%'
}) => {
  const [sliderValue, setSliderValue] = useState(value);
  const sliderRef = useRef(null);

  useEffect(() => {
    setSliderValue(value);
  }, [value]);

  const handleSliderChange = (e) => {
    const newValue = parseFloat(e.target.value);
    setSliderValue(newValue);
    onChange(newValue);
  };

  const getBackgroundSize = () => {
    return { backgroundSize: `${((sliderValue - min) * 100) / (max - min)}% 100%` };
  };

  return (
    <div className={`my-slider ${disabled ? 'disabled' : ''}`}>
      <input
        ref={sliderRef}
        type="range"
        min={min}
        max={max}
        step={step}
        value={sliderValue}
        onChange={handleSliderChange}
        className="slider"
        disabled={disabled}
        style={getBackgroundSize()}
      />
      {showLabels && (
        <div className="slider-labels">
          <span>{min}{valueSuffix}</span>
          <span>{max}{valueSuffix}</span>
        </div>
      )}
      {showValue && (
        <div className="slider-value">{valuePrefix}{sliderValue.toFixed(1)}{valueSuffix}</div>
      )}
    </div>
  );
};

export default MySlider;